// extracted by mini-css-extract-plugin
module.exports = {"courseCardContent":"CourseCard_courseCardContent__2W4Er","viewDetail":"CourseCard_viewDetail__rY80G","duration":"CourseCard_duration__YJhD6"};